import { useTheme } from '@automata/mui-theme';
import { Group } from '@visx/group';

export const AxisTickComponent = ({
  formattedValue,
  index,
  x,
  y,
}: {
  formattedValue?: string;
  index: number;
  x: number;
  y: number;
}) => {
  const theme = useTheme();
  const isMajor = index % 10 === 0;

  return (
    <Group top={y} left={x}>
      {isMajor && (
        <text
          y={-18}
          fontSize={theme.typography.overline.fontSize}
          fontFamily={theme.typography.overline.fontFamily}
          fontWeight={theme.typography.overline.fontWeight}
          color={theme.palette.text.primary}
          textAnchor="start"
        >
          {formattedValue}
        </text>
      )}
      <line
        y2={isMajor ? -16 : -8}
        stroke={theme.palette.neutral[600]}
        data-testid={`tick-line-${isMajor ? 'major' : 'normal'}-${index}`}
      />
    </Group>
  );
};
